<template>
  <div>
    <div class="main-content fe-account-page">
      <div class="container py-4 py-lg-5">
        <header class="fe-account-page__header">
          <h1 class="fe-account-page__title">Wishlist</h1>
          <p class="fe-account-page__subtitle">
            Products you saved with the heart icon. Open one to buy or remove it anytime.
          </p>
        </header>

        <div class="row g-4 align-items-start">
          <div class="col-lg-3 col-md-4">
            <account-sidebar />
          </div>
          <div class="col-lg-9 col-md-8">
            <wishlist-area embedded />
          </div>
        </div>
      </div>
    </div>

    <cta-area />
  </div>
</template>

<script>
import AccountSidebar from '@/components/account/AccountSidebar.vue'
import WishlistArea from '@/components/wishlist/wishlist-area.vue'
import CtaArea from '@/components/cta/cta-area.vue'

export default {
  name: 'WishlistPage',
  components: {
    AccountSidebar,
    WishlistArea,
    CtaArea,
  },
  metaInfo() {
    return { title: 'Wishlist' }
  },
}
</script>

<style scoped>
/* Match my-account / my-address: header typography comes from fe-account-page in child CSS */
.fe-account-page {
  font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, 'Helvetica Neue', sans-serif;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 120px);
  color: #1f2937;
}

.fe-account-page__header {
  text-align: center;
  margin-bottom: 2.25rem;
}

.fe-account-page__title {
  font-size: clamp(1.95rem, 4.2vw, 2.45rem);
  font-weight: 800;
  letter-spacing: -0.025em;
  color: #0f172a;
  margin: 0 0 0.6rem;
  line-height: 1.15;
}

.fe-account-page__subtitle {
  margin: 0 auto;
  max-width: 560px;
  font-size: 18px;
  color: #475569;
  line-height: 1.55;
  font-weight: 500;
  letter-spacing: 0.005em;
}
</style>
